document.addEventListener('DOMContentLoaded', () => {
	//auto add variant to cart when customers click checkout in cart drawer
	const autoATC = (e) => {
		// detect checkout submit specifically
		const btn = e.submitter;

		if (!btn || btn.name !== 'checkout') return;

		// const checkoutBtn = document.activeElement;
		// if (checkoutBtn && checkoutBtn.name === "checkout") {
			e.preventDefault(); // stop normal submit
			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					id: 46637241565351, // variant id
					quantity: 1
				})
			})
			.then(response => response.json())
			.then(data => {
				// continue normal checkout
				// this.submit();
				// console.log("data", data);
				window.location.href = '/checkout';
			})
			.catch(error => {
				console.error('Error:', error);
			});
		// }
	};

	//add listener to cart drawer checkout button
	document.querySelector('form.drawer__footer-buttons')?.addEventListener('submit', autoATC);
	//add event listener to cart drawer panel (the one showing after adding an item to cart) checkout button
	document.querySelector('.cdrawer__panel .cdrawer__actions form')?.addEventListener('submit', autoATC);
});